import { ModelManager } from '../api-kv'

/* -------------------------------------------------------------------------------------------------
 * Block Usage: used for billing purposes.
 * -----------------------------------------------------------------------------------------------*/

export type BlockUsage = {
  total: number
  byRepoIds: Record<string, number>
} | null

export const blockUsageSchema: ModelManager<string, BlockUsage> = {
  getKey: (teamId) => `team-blocks-usage:${teamId}`,
  get: async (client, teamId) => {
    const key = blockUsageSchema.getKey(teamId)
    return await client.get(key)
  },
  set: async (client, teamId, data) => {
    const key = blockUsageSchema.getKey(teamId)
    await client.set(key, data)
  },
}
